import React from "react";
import PublicIcon from "@mui/icons-material/Public";
import withStyles from "isomorphic-style-loader/withStyles";
import {
  Col,
  Collapse,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
  Row,
} from "reactstrap";
import get from "lodash.get";
import isequal from "lodash.isequal";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import * as userActions from "../../../../utils/actions/user";
import * as modalActions from "../../../../utils/actions/modals";
import * as commonActions from "../../../../utils/actions/common";
import { clearPostLoginPhoneScreenSkip } from "../../../../utils/adminPhonePrompt";
import { clearSessionAccessToken, isUsableServiceAccessToken } from "../../../../utils/firebaseToken";
import s from "./styles.scss";
import {
  isAdminDebugUiActive,
  toggleAdminDebugUi,
} from "../../../../utils/adminDebugUi";
import {
  ModalProps,
  serviceCaller,
  ServiceCallerProps,
  subscribeToResizeChanges,
  UserCharitiesProps,
  withModals,
  withUserCharities,
} from "../../../composition";
import { firebaseConnect, isLoaded } from "react-redux-firebase";
import {
  isCurrentUserAdmin,
  isCurrentUserCollaborator,
  isCurrentUserOnlyCollaborator,
  isCurrentUserOnlyReader,
  isCurrentUserPublisher,
} from "../../../../utils/roleCheck";

import Select, { GroupBase, OptionsOrGroups, StylesConfig } from "react-select";
import ICharity from "../../../../types/services/ICharity";
import { messengerAvailability } from "../../../../utils/fetch";
import { ExportType } from "../../exportModal";
import CreateCharityWizard from "../../Superadmin/createCharityWizard";
import IUser from "../../../../types/services/IUser";
import ReactTooltip from "react-tooltip";
import { ScaleLoader } from "react-spinners";
import { subscribeCharityNamesPrefetch, ensureCharityPickerMetadata } from "../../../../utils/charityMetadataPrefetch";
import {
  CHARITY_CUSTOMIZE_HUB_PATH,
  ONBOARDING_DASHBOARD_PATH,
} from "../../../../utils/onboarding/stepNavigation";
import { showOnboardingNav } from "../../../../utils/onboarding/onboardingAccess";
import { countUnreadThreads } from "../../../../utils/messengerInbox";

const EXCLUDED_CHARITY_IDS = new Set(["superadmin", "donation-reader"]);

type CharitySelectOption = {
  value: string;
  label: string;
  charity: ICharity;
};

type CharitySelectGroup = GroupBase<CharitySelectOption>;

export enum HeaderType {
  admin,
  superadmin,
}

import { selectUsesGiveSpark } from "../../../../utils/giveSpark";
interface Props extends UserCharitiesProps, ServiceCallerProps, ModalProps {
  firebase: any;
  allUpdate: boolean;
  name: string;
  photoUrl: string;
  shouldRemember: boolean;
  showViewsparkButton: boolean;
  headerType: HeaderType;
  charityHasApps: boolean;
  whitelabelUrl: string | null;
  disableMessenger: boolean;

  logoutCurrentUser: (remember: boolean) => void;
  toggleUserProfileModal: () => void;
  messengerIsAvailable: (available: boolean) => void;
  loginUser: (user?: IUser, currentCharity?: ICharity, charities?: ICharity[]) => void;

  showMessenger: boolean;
  mobileMode: boolean;

  enableAdminMetrics: boolean;
  enableDonorPerfect: boolean;
  enableVirtuous: boolean;
  unreadMessages: { [key: string]: number };
  disableGiveSpark: boolean;
  isAdminDebugUi: boolean;
  charitiesRegistry: Record<string, boolean>;
  showDashboard: boolean;
}

interface State {
  profileDropdownOpen: boolean;
  adminProfileOptions: Array<string>;
  superadminProfileOptions: Array<string>;
  disabledProfileOptions: Array<number>;
  dropdownProfileItems: Array<any>;
  disableAppsAllowedCharities: Array<String>;
  profileOption: string;
  collapsed: boolean;
  isOpen: boolean;
  createCharityWizardOpen: boolean;
  charityNamesPrefetching: boolean;
  charityPickerMenuOpen: boolean;
}

// ponytail: survives Header remount on every route (each container mounts its own Layout)
let messengerAvailabilityCompletedKey: string | null = null;
let messengerAvailabilityInFlight: string | null = null;

class Header extends React.Component<Props, State> {
  private unsubCharityNamesPrefetch: (() => void) | null = null;

  state = {
    profileDropdownOpen: false,
    adminProfileOptions: ["View Profile", "Sign Out"],
    superadminProfileOptions: [
      "View Profile",
      "Global Settings",
      "Monthly Report",
      "Notifications",
      "Debug mode",
      "Sign Out",
    ],
    disabledProfileOptions: [],
    dropdownProfileItems: [],
    disableAppsAllowedCharities: ["sample-charity", "abc"],
    profileOption: "",
    collapsed: false,
    isOpen: false,
    createCharityWizardOpen: false,
    charityNamesPrefetching: false,
    charityPickerMenuOpen: false,
  };

  static defaultProps = {
    headerType: HeaderType.admin,
  };

  componentDidMount() {
    this.updateItems();
    this.unsubCharityNamesPrefetch = subscribeCharityNamesPrefetch(
      inProgress => {
        this.setState({ charityNamesPrefetching: inProgress });
      }
    );
    this.checkMessengerAvailability();
  }

  componentWillUnmount() {
    this.unsubCharityNamesPrefetch?.();
    this.unsubCharityNamesPrefetch = null;
  }

  componentDidUpdate(prevProps: Props) {
    if (!isequal(this.props.charities, prevProps.charities)) {
      this.updateItems();
    }
    if (!isequal(this.props.currentCharity, prevProps.currentCharity)) {
      this.updateItems();
    }

    if (this.props.charityHasApps !== prevProps.charityHasApps) {
      this.updateItems();
    }
    if (!this.props.currentCharity.name && this.props.charities) {
      let index = this.props.charities.findIndex(
        elem => elem.id === this.props.currentCharity.id
      );
      if (this.props.charities[index] && this.props.charities[index].name) {
        this.props.changeCurrentCharity(this.props.charities[index]);
        this.updateItems();
      }
    }

    this.maybeScheduleMessengerAvailabilityCheck(prevProps);

    if (
      !this.props.showMessenger &&
      this.props.location.pathname.startsWith("/messages")
    ) {
      this.goBack();
    }

  }

  updateItems = () => {
    let profileItems = this.calculateDropdownProfileItems();
    this.setState({
      dropdownProfileItems: profileItems,
    });
  };

  openProfileDropdown = () => {
    this.setState({
      profileDropdownOpen: !this.state.profileDropdownOpen,
    });
  };

  charityDropdownLabel = (charity: { id: string; name?: string }) => {
    if (!this.props.isAdminDebugUi) {
      return !charity.name ? charity.id : charity.name;
    }
    const name = charity.name || "";
    return name ? `${name} | ${charity.id}` : charity.id;
  };

  isCharityRegistryActive = (charityId: string): boolean => {
    const flag = this.props.charitiesRegistry[charityId];
    return flag !== false;
  };

  listSelectableCharities = (): ICharity[] =>
    this.props.charities.filter(c => !EXCLUDED_CHARITY_IDS.has(c.id));

  hasMultipleSelectableCharities = (): boolean =>
    this.listSelectableCharities().length > 1;

  toCharitySelectOption = (charity: ICharity): CharitySelectOption => ({
    value: charity.id,
    label: this.charityDropdownLabel(charity),
    charity,
  });

  buildCharitySelectGroups = (): OptionsOrGroups<
    CharitySelectOption,
    CharitySelectGroup
  > => {
    const active: CharitySelectOption[] = [];
    const inactive: CharitySelectOption[] = [];

    this.listSelectableCharities().forEach(charity => {
      const option = this.toCharitySelectOption(charity);
      if (this.isCharityRegistryActive(charity.id)) {
        active.push(option);
      } else {
        inactive.push(option);
      }
    });

    const sortByLabel = (a: CharitySelectOption, b: CharitySelectOption) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" });

    active.sort(sortByLabel);
    inactive.sort(sortByLabel);

    const groups: CharitySelectGroup[] = [];
    if (active.length > 0) {
      groups.push({ label: "Active", options: active });
    }
    if (inactive.length > 0) {
      groups.push({ label: "Inactive", options: inactive });
    }
    return groups;
  };

  getCharitySelectValue = (): CharitySelectOption | null => {
    const current = this.props.currentCharity;
    if (!current?.id || EXCLUDED_CHARITY_IDS.has(current.id)) {
      return null;
    }
    return this.toCharitySelectOption(current);
  };

  filterCharitySelectOption = (
    option: { data: CharitySelectOption },
    rawInput: string
  ): boolean => {
    const input = rawInput.trim().toLowerCase();
    if (!input) {
      return true;
    }
    const charity = option.data.charity;
    const name = (charity.name || "").toLowerCase();
    if (this.props.isAdminDebugUi) {
      return name.includes(input) || charity.id.toLowerCase().includes(input);
    }
    if (name) {
      return name.includes(input);
    }
    return charity.id.toLowerCase().includes(input);
  };

  onCharitySelectChange = (option: CharitySelectOption | null) => {
    if (!option) {
      return;
    }
    const charity = this.props.charities.find(c => c.id === option.value);
    if (charity) {
      this.props.changeCurrentCharity(charity);
    }
  };

  onCharityPickerMenuOpen = () => {
    this.setState({ charityPickerMenuOpen: true });
    void ensureCharityPickerMetadata(this.props.charities, merged => {
      this.props.updateCharities(merged);
    });
  };

  onCharityPickerMenuClose = () => {
    this.setState({ charityPickerMenuOpen: false });
  };

  charityLabelForWidth = (charity: ICharity): string => {
    const name = charity.name || "";
    return name ? `${name} | ${charity.id}` : charity.id;
  };

  getCharitySelectMinWidthCh = (): number => {
    let maxChars = 0;
    this.listSelectableCharities().forEach(charity => {
      const widths = [
        this.charityDropdownLabel(charity).length,
        this.charityLabelForWidth(charity).length,
        charity.id.length,
      ];
      maxChars = Math.max(maxChars, ...widths);
    });
    return maxChars + 3;
  };

  getCharitySelectContainerStyle = (): React.CSSProperties => ({
    minWidth: `${this.getCharitySelectMinWidthCh()}ch`,
  });

  formatCharitySelectGroupLabel = (group: CharitySelectGroup) => (
    <div className={s.charitySelectGroupHeading}>
      <span>{group.label}</span>
      {group.label === "Active" && this.renderCreateCharityButton()}
    </div>
  );

  renderCharityLiveSiteButton = (): JSX.Element => {
    const siteUrl = this.props.whitelabelUrl?.trim().replace(/\/+$/, "");
    const hasSiteUrl = !!siteUrl && /^https?:\/\//i.test(siteUrl);

    return (
      <>
        <button
          type="button"
          className={s.charitySettingsButton}
          aria-label="Live Site (opens in a new tab)"
          data-tip
          data-for="charityLiveSiteTooltip"
          disabled={!hasSiteUrl}
          onClick={() => window.open(siteUrl, "_blank", "noopener,noreferrer")}
        >
          <PublicIcon fontSize="inherit" aria-hidden="true" />
        </button>
        <ReactTooltip
          id="charityLiveSiteTooltip"
          type="info"
          place="bottom"
          effect="float"
        >
          Live Site
        </ReactTooltip>
      </>
    );
  };

  renderCharityCustomizeButton = (): JSX.Element | null => {
    if (!this.props.isSuperadmin) {
      return null;
    }
    return (
      <>
        <button
          type="button"
          className={s.charitySettingsButton}
          aria-label="Customize charity"
          data-tip
          data-for="charityCustomizeTooltip"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.props.navigate(CHARITY_CUSTOMIZE_HUB_PATH);
          }}
        >
          <i className="fas fa-pencil-alt" aria-hidden="true" />
        </button>
        <ReactTooltip
          id="charityCustomizeTooltip"
          type="info"
          place="bottom"
          effect="float"
        >
          Customize charity
        </ReactTooltip>
      </>
    );
  };

  renderCharitySettingsButton = (): JSX.Element | null => {
    if (!this.props.isSuperadmin) {
      return null;
    }
    return (
      <>
        <button
          type="button"
          className={s.charitySettingsButton}
          aria-label="Charity settings"
          data-tip
          data-for="charitySettingsTooltip"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.props.navigate(`${ONBOARDING_DASHBOARD_PATH}/settings`);
          }}
        >
          <i className="fas fa-cog" aria-hidden="true" />
        </button>
        <ReactTooltip
          id="charitySettingsTooltip"
          type="info"
          place="bottom"
          effect="float"
        >
          Charity settings
        </ReactTooltip>
      </>
    );
  };

  renderCreateCharityButton = (): JSX.Element | null => {
    if (!this.props.isSuperadmin) {
      return null;
    }
    return (
      <>
        <button
          type="button"
          className={s.addCharityButton}
          aria-label="Create a new charity"
          data-tip
          data-for="createCharityTooltip"
          onMouseDown={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ createCharityWizardOpen: true });
          }}
        >
          +
        </button>
        <ReactTooltip
          id="createCharityTooltip"
          type="info"
          place="left"
          effect="float"
        >
          Create a new charity
        </ReactTooltip>
      </>
    );
  };

  toggleCreateCharityWizard = () => {
    this.setState(state => ({
      createCharityWizardOpen: !state.createCharityWizardOpen,
    }));
  };

  charitySelectStyles: StylesConfig<
    CharitySelectOption,
    false,
    CharitySelectGroup
  > = {
    control: base => ({
      ...base,
      minHeight: "41px",
      height: "auto",
      padding: "4px 0",
      border: "none",
      boxShadow: "none",
    }),
    menu: base => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
    }),
    menuList: base => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    groupHeading: base => ({
      ...base,
      fontFamily: "inherit",
      fontSize: "13px",
      fontWeight: 600,
      color: "#58585d",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      margin: "6px 12px 2px",
      padding: 0,
    }),
    singleValue: base => ({
      ...base,
      maxWidth: "none",
      position: "static",
      transform: "none",
      backgroundColor: "transparent",
      color: "#48484d",
      fontSize: "28px",
      fontWeight: 400,
      lineHeight: "33px",
      fontFamily: "Inter, sans-serif",
    }),
    valueContainer: base => ({
      ...base,
      flexWrap: "nowrap",
      padding: "4px 0",
      height: "auto",
    }),
    indicatorsContainer: base => ({
      ...base,
      padding: "4px 0",
      height: "auto",
    }),
    dropdownIndicator: base => ({
      ...base,
      padding: "0 0 0 4px",
      color: "#48484d",
    }),
    input: base => ({
      ...base,
      margin: 0,
      padding: 0,
      color: "#48484d",
      fontSize: "28px",
      fontWeight: 400,
      lineHeight: "33px",
      fontFamily: "Inter, sans-serif",
    }),
    option: (base, state) => {
      const baseTypography = {
        textAlign: "center" as const,
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: 500,
        borderBottom: "1px solid #e8e8e8",
        cursor: "pointer",
        padding: "6px 16px",
      };
      if (state.isSelected) {
        return {
          ...base,
          ...baseTypography,
          color: "#fff",
          backgroundColor: "#0B4F8D",
        };
      }
      if (state.isFocused) {
        return {
          ...base,
          ...baseTypography,
          color: "#fff",
          backgroundColor: "#1f65b1",
        };
      }
      return {
        ...base,
        ...baseTypography,
        color: "#1f65b1",
        backgroundColor: "#fff",
      };
    },
  };

  selectProfileItem = async e => {
    this.setState({
      profileOption: e.currentTarget.textContent,
    });
    if (e.currentTarget.textContent === "Sign Out") {
      clearPostLoginPhoneScreenSkip();
      clearSessionAccessToken();
      this.props.logoutCurrentUser(this.props.shouldRemember);
      this.props.firebase.logout();
      this.props.navigate("/");
    } else if (e.currentTarget.textContent === "View Profile") {
      this.setState(
        {
          profileDropdownOpen: false,
        },
        () => {
          this.props.toggleUserProfileModal();
        }
      );
    } else if (e.currentTarget.textContent === "Global Settings") {
      if (this.props.isDonationReader) {
        this.props.navigate("/allDonations");
      } else if (this.props.isSuperadmin) {
        this.props.navigate("/allDonations");
      }
    } else if (e.currentTarget.textContent === "Notifications") {
      this.setState({ profileDropdownOpen: false }, () => {
        this.props.navigate("/system-notifications");
      });
    } else if (e.currentTarget.textContent === "Debug mode") {
      if (!this.props.isSuperadmin) {
        return;
      }
      toggleAdminDebugUi();
      window.location.reload();
    } else if (e.currentTarget.textContent === "Monthly Report") {
      this.props.toggleExportModal(
        ExportType.monthlyReport,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        true
      );
    } else if (
      this.state.disableAppsAllowedCharities.includes(
        this.props.currentCharity.id
      ) &&
      e.currentTarget.textContent === "Disable Apps"
    ) {
      await this.props.firebase
        .database()
        .ref(this.props.currentCharity.id)
        .child("config")
        .child("hasApps")
        .set(false);
    } else if (
      this.state.disableAppsAllowedCharities.includes(
        this.props.currentCharity.id
      ) &&
      e.currentTarget.textContent === "Enable Apps"
    ) {
      await this.props.firebase
        .database()
        .ref(this.props.currentCharity.id)
        .child("config")
        .child("hasApps")
        .set(true);
    }
  };

  goBack = () => {
    this.props.navigate("/contacts");
  };

  createPost = () => {
    this.props.navigate("/viewsparks/new");
  };

  calculateDropdownProfileItems = () => {
    let dropDownProfileItems: Array<any> = [];
    let profileOptions: Array<string> = [];
    if (
      (this.props.headerType === HeaderType.admin ||
        this.props.headerType === HeaderType.superadmin) &&
      this.props.isSuperadmin
    ) {
      profileOptions = this.state.superadminProfileOptions;
    } else {
      profileOptions = this.state.adminProfileOptions;
    }
    for (let i = 0; i < profileOptions.length; i++) {
      dropDownProfileItems.push(
        <DropdownItem
          id={profileOptions[i]}
          key={i}
          active={false}
          onClick={this.selectProfileItem}
          disabled={
            this.state.disabledProfileOptions.filter(value => value === i)
              .length > 0
          }
          className={s.dropdownItem + " " + s.centerAlign}
        >
          {profileOptions[i]}
        </DropdownItem>
      );
    }
    if (
      this.state.disableAppsAllowedCharities.includes(
        this.props.currentCharity.id
      )
    ) {
      dropDownProfileItems.splice(
        dropDownProfileItems.length - 1,
        0,
        <DropdownItem
          id={this.props.currentCharity.id + "apps"}
          key={"abc" + "apps"}
          active={false}
          onClick={this.selectProfileItem}
          className={s.dropdownItem + " " + s.centerAlign}
        >
          {this.props.charityHasApps ? "Disable Apps" : "Enable Apps"}
        </DropdownItem>
      );
    }
    return dropDownProfileItems;
  };

  maybeScheduleMessengerAvailabilityCheck = (prevProps: Props): void => {
    const charityId = this.props.currentCharity?.id;
    const notificationUrl = this.props.config?.notificationServiceUrl;
    if (!charityId || !notificationUrl) {
      return;
    }
    const tokenReady = isUsableServiceAccessToken(this.props.serviceAccessToken);
    if (!tokenReady) {
      return;
    }

    const prevCharityId = prevProps.currentCharity?.id;
    const prevUrl = prevProps.config?.notificationServiceUrl;
    const prevTokenReady = isUsableServiceAccessToken(
      prevProps.serviceAccessToken
    );
    const identityChanged =
      charityId !== prevCharityId || notificationUrl !== prevUrl;
    const tokenJustReady = tokenReady && !prevTokenReady;

    if (identityChanged || tokenJustReady) {
      this.checkMessengerAvailability();
    }
  };

  checkMessengerAvailability = (): void => {
    const charityId = this.props.currentCharity?.id;
    const url = this.props.config?.notificationServiceUrl;
    const token = this.props.serviceAccessToken;
    if (!charityId || !url || !isUsableServiceAccessToken(token)) {
      return;
    }

    const key = `${charityId}\0${url}`;
    if (
      messengerAvailabilityCompletedKey === key ||
      messengerAvailabilityInFlight === key
    ) {
      return;
    }
    messengerAvailabilityInFlight = key;

    messengerAvailability(url, charityId, token)
      .then(response => {
        this.props.messengerIsAvailable(response.success);
      })
      .catch(_ => {
        /* auth/transient errors must not hide Messenger for the session */
      })
      .finally(() => {
        messengerAvailabilityCompletedKey = key;
        if (messengerAvailabilityInFlight === key) {
          messengerAvailabilityInFlight = null;
        }
      });
  };

  renderNavItemsFromOptions = options => {
    return options.map(
      (option, index) =>
        option.validation && (
          <NavItem className={s.navItem} key={option + "_" + index}>
            <NavLink
              className={
                option.customClass
                  ? option.customClass
                  : this.props.location.pathname.startsWith(option.url)
                  ? s.activeNavText
                  : s.navText
              }
              to={option.url}
            >
              {option.title}
              {option.notifications && (
                <div className={classNames(s.notifications, s.red)}>
                  {option.notifications}
                </div>
              )}
            </NavLink>
          </NavItem>
        )
    );
  };

  adminNavbarOptions = (): any => {
    const isAdmin = isCurrentUserAdmin(this.props.currentCharity);
    const isPublisher = isCurrentUserPublisher(this.props.currentCharity);
    const isReader = isCurrentUserOnlyReader(this.props.currentCharity);
    const enableAcademy =
      this.props.config && this.props.config.enableAcademy
        ? this.props.config.enableAcademy
        : false;
    const notCollaborator = !isCurrentUserOnlyCollaborator(
      this.props.currentCharity
    );

    const { disableMessenger } = this.props;
    const options = [
      {
        title: "Onboarding",
        url: ONBOARDING_DASHBOARD_PATH,
        validation: this.props.showDashboard
      },
      {
        title: "Metrics",
        url: "/charityMetrics",
        validation:
          this.props.isSuperadmin || (this.props.enableAdminMetrics && isAdmin),
      },
      { title: "Contacts", url: "/contacts", validation: notCollaborator },
      {
        title: "GiveSpark",
        url: this.props.disableGiveSpark ? "#" : "/donations",
        validation: !this.props.currentCharity.disableGive && notCollaborator,
        customClass: this.props.disableGiveSpark ? s.disabledNavText : null,
      },
      { title: "Segments", url: "/segments", validation: notCollaborator },
      { title: "ViewSpark", url: "/viewsparks", validation: true },
      { title: "Request Content", url: "/requests", validation: true },
      { title: "Users", url: "/users", validation: isAdmin },
      {
        title: "Messenger",
        url: disableMessenger || !this.props.showMessenger ? "#" : "/messages",
        validation: isAdmin || isPublisher || isReader,
        notifications: countUnreadThreads(this.props.unreadMessages) || null,
        customClass:
          disableMessenger || !this.props.showMessenger
            ? s.disabledNavText
            : null,
      },
      {
        title: "Keywords",
        url: "/keywords",
        validation: isAdmin || isPublisher || isReader,
      },
      { title: "Upload File", url: "/import", validation: isAdmin },
      { title: "Support", url: "/academy", validation: enableAcademy },
      {
        title: "Integrations",
        url: "/integrations",
        validation:
          isAdmin &&
          (this.props.enableDonorPerfect || this.props.enableVirtuous),
      },
    ];

    return this.renderNavItemsFromOptions(options);
  };

  renderDesktopAdminNavbar = (): JSX.Element => {
    return (
      <Nav navbar className="me-auto flex-row gap-3">
        {this.adminNavbarOptions()}

        {this.props.showViewsparkButton &&
          isCurrentUserCollaborator(this.props.currentCharity) && (
            <NavItem className={s.navItemViewspark} key={"createViewspark"}>
              <div className={s.viewsparkButton} onClick={this.createPost} />
            </NavItem>
          )}
      </Nav>
    );
  };

  renderMobileAdminNavbar = (): JSX.Element => {
    return (
      <Navbar color="faded" light>
        <NavbarToggler onClick={this.toggleNavbar} />
        <Collapse isOpen={!this.state.collapsed} navbar>
          <Nav navbar>
            {this.adminNavbarOptions()}
            {this.props.showViewsparkButton &&
              isCurrentUserCollaborator(this.props.currentCharity) && (
                <NavItem className={s.navItemViewspark}>
                  <div
                    className={s.viewsparkButton}
                    onClick={this.createPost}
                  />
                </NavItem>
              )}
          </Nav>
        </Collapse>
      </Navbar>
    );
  };

  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  renderAdminNavbar = () => {
    return this.props.mobileMode
      ? this.renderMobileAdminNavbar()
      : this.renderDesktopAdminNavbar();
  };

  renderSuperadminNavbar = () => {
    const superAdminOptions = [
      { title: "Donation Log", url: "/allDonations", validation: true },
      { title: "Api Key Manager", url: "/apiKeys", validation: true },
      { title: "URL Manager", url: "/urlManager", validation: true },
      { title: "Metrics", url: "/metrics", validation: true },
      { title: "Chat", url: "/chat-session", validation: true },
      { title: "Notifications", url: "/system-notifications", validation: true },
    ];
    return <Nav navbar className="me-auto flex-row gap-3">{this.renderNavItemsFromOptions(superAdminOptions)}</Nav>;
  };

  render() {
    return (
      <div className={s.root}>
        <Container fluid>
          <div className={s.banner} />
          <Row>
            {this.props.headerType === HeaderType.admin && (
              <Col xs={12} md={4}>
                <Navbar light expand="md" className={s.navBar}>
                  <Nav className="me-auto" navbar>
                    <div className={s.charitySelectRow}>
                      <div
                      id="charitiesDropdown"
                      className={classNames(
                        s.charitySelect,
                        !this.hasMultipleSelectableCharities() &&
                          s.charitySelectStatic
                      )}
                      style={
                        this.hasMultipleSelectableCharities()
                          ? this.getCharitySelectContainerStyle()
                          : undefined
                      }
                      data-elm-id="charitiesDropdown"
                    >
                      {this.hasMultipleSelectableCharities() ? (
                        <>
                          {this.state.charityNamesPrefetching &&
                            this.state.charityPickerMenuOpen && (
                              <span
                                className={s.charitySelectSpinner}
                                aria-hidden="true"
                              >
                                <ScaleLoader
                                  color="#1f65b1"
                                  height={16}
                                  width={3}
                                  loading
                                />
                              </span>
                            )}
                          <Select<CharitySelectOption, false, CharitySelectGroup>
                            inputId="charitiesDropdownInput"
                            instanceId="charitiesDropdown"
                            value={this.getCharitySelectValue()}
                            onChange={this.onCharitySelectChange}
                            options={this.buildCharitySelectGroups()}
                            formatGroupLabel={this.formatCharitySelectGroupLabel}
                            filterOption={this.filterCharitySelectOption}
                            isSearchable
                            isClearable={false}
                            openMenuOnFocus
                            blurInputOnSelect
                            onMenuOpen={this.onCharityPickerMenuOpen}
                            onMenuClose={this.onCharityPickerMenuClose}
                            placeholder={this.charityDropdownLabel(
                              this.props.currentCharity
                            )}
                            classNamePrefix="charity-select"
                            styles={this.charitySelectStyles}
                            aria-label="Select charity"
                          />
                        </>
                      ) : (
                        <span className={s.charitySelectStaticRow}>
                          <span className={s.charitySelectStaticLabel}>
                            {this.charityDropdownLabel(this.props.currentCharity)}
                          </span>
                          {this.renderCreateCharityButton()}
                        </span>
                      )}
                      </div>
                      {this.renderCharityLiveSiteButton()}
                      {this.renderCharityCustomizeButton()}
                      {this.renderCharitySettingsButton()}
                    </div>
                  </Nav>
                </Navbar>
              </Col>
            )}
            {this.props.headerType === HeaderType.superadmin &&
              !this.props.isDonationReader && (
                <Col xs={6} className={s.noPadding}>
                  <div onClick={this.goBack} className={s.cursor}>
                    <div className={s.arrowLeftContainer}>
                      <div className={s.arrowLeft} />
                    </div>
                    <Label className={classNames(s.backLabel, s.cursor)}>
                      Back to charities
                    </Label>
                  </div>
                </Col>
              )}
            <Col xs={12} md={8} className={s.colMargin}>
              <div>
                <i className={"fas fa-bell " + s.icon}>&nbsp;</i>
                <span className={s.text}>{this.props.name}</span>
                <Dropdown
                  isOpen={this.state.profileDropdownOpen}
                  className={s.hiddenDropdown}
                  toggle={this.openProfileDropdown}
                >
                  <DropdownToggle
                    caret
                    className={classNames(s.dropdown, s.dropdownProfile)}
                    color={"none"}
                  />
                  <DropdownMenu
                    id={"dropdownMenu"}
                    className={classNames(
                      s.dropdownMenu,
                      s.dropdownMenuProfile
                    )}
                  >
                    {this.state.dropdownProfileItems}
                  </DropdownMenu>
                  {!this.props.photoUrl && (
                    <i
                      className={
                        "fas fa-user-circle " + s.userIcon + " " + s.photo
                      }
                      onClick={this.openProfileDropdown}
                    >
                      &nbsp;
                    </i>
                  )}
                  {this.props.photoUrl && (
                    <img
                      src={this.props.photoUrl}
                      alt="Profile"
                      decoding="sync"
                      className={s.photo}
                      onClick={this.openProfileDropdown}
                    />
                  )}
                </Dropdown>
              </div>
            </Col>
          </Row>
          {this.props.headerType === HeaderType.admin &&
            this.renderAdminNavbar()}
          {this.props.headerType === HeaderType.superadmin &&
            this.renderSuperadminNavbar()}
        </Container>
        <CreateCharityWizard
          isOpen={this.state.createCharityWizardOpen}
          toggle={this.toggleCreateCharityWizard}
          config={this.props.config}
          serviceAccessToken={this.props.serviceAccessToken}
          firebase={this.props.firebase}
          loginUser={this.props.loginUser}
          changeCurrentCharity={this.props.changeCurrentCharity}
          navigate={this.props.navigate}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { firebase, user, common } = state;

  const hasApps =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].config) &&
    isLoaded(firebase.data[user.currentCharity.id].config.hasApps)
      ? get(firebase, `data.${user.currentCharity.id}.config.hasApps`)
      : true;
  const disableMessenger =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].config) &&
    isLoaded(firebase.data[user.currentCharity.id].config.disableMessenger)
      ? get(firebase, `data.${user.currentCharity.id}.config.disableMessenger`)
      : false;

  const unreadMessages =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].smsNotifications)
      ? get(
          firebase,
          `data.${user.currentCharity.id}.smsNotifications[${user.id}]`
        )
      : {};

  const enableAdminMetrics =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].config) &&
    isLoaded(firebase.data[user.currentCharity.id].config.enableAdminMetrics)
      ? get(
          firebase,
          `data.${user.currentCharity.id}.config.enableAdminMetrics`
        )
      : false;

  const enableDonorPerfect =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].config) &&
    isLoaded(firebase.data[user.currentCharity.id].config.enableDonorPerfect)
      ? get(
          firebase,
          `data.${user.currentCharity.id}.config.enableDonorPerfect`
        )
      : false;
  const enableVirtuous =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].config) &&
    isLoaded(firebase.data[user.currentCharity.id].config.enableVirtuous)
      ? get(firebase, `data.${user.currentCharity.id}.config.enableVirtuous`)
      : false;

  return {
    whitelabelUrl: get(firebase, `data.${user.currentCharity.id}.config.whitelabelUrl`) || null,
    name: user.name,
    photoUrl: user.photoUrl,
    shouldRemember: user.remember,
    isAdminDebugUi: isAdminDebugUiActive(user.isSuperadmin),
    showViewsparkButton: common.showViewsparkButton,
    showMessenger: common.showMessenger,
    disableMessenger:
      typeof disableMessenger !== "undefined" && disableMessenger !== null
        ? disableMessenger
        : false,
    charityHasApps:
      typeof hasApps !== "undefined" && hasApps !== null ? hasApps : true,
    unreadMessages,
    enableAdminMetrics,
    enableDonorPerfect,
    enableVirtuous,
    disableGiveSpark: !selectUsesGiveSpark(state),
    showDashboard: showOnboardingNav(
      user,
      firebase.data,
      user.currentCharity.id
    ),
    charitiesRegistry: get(firebase, "data.charities") || {},
  };
};

const mapDispatchToProps = dispatch => ({
  logoutCurrentUser: (remember = null) => {
    dispatch(userActions.logoutCurrentUser(remember));
  },
  toggleUserProfileModal: () => {
    dispatch(modalActions.toggleUserProfileModal());
  },
  messengerIsAvailable: (available: boolean) => {
    dispatch(commonActions.messengerIsAvailable(available));
  },
  loginUser: (user = null, currentCharity = null, charities = null) => {
    dispatch(userActions.loginUser(user, currentCharity, charities));
  },
});

export default serviceCaller(
  withUserCharities(
    connect<Props>(
      mapStateToProps,
      mapDispatchToProps
    )(
      firebaseConnect((_, store) => {
        const paths: string[] = store.getState().user.charities
          .filter(charity => charity.id && !EXCLUDED_CHARITY_IDS.has(charity.id))
          .map(charity => `charities/${charity.id}`);
        const charityId = store.getState().user.currentCharity.id;
        if (charityId !== "") {
          paths.push(
            `${charityId}/config/hasApps`,
            `${charityId}/config/disableMessenger`,
            `${charityId}/smsNotifications/${store.getState().user.id}`,
            `${charityId}/config/customDonationUrl`,
            `${charityId}/config/whitelabelUrl`,
            `${charityId}/config/enableAdminMetrics`,
            `${charityId}/config/enableDonorPerfect`,
            `${charityId}/config/enableVirtuous`,
            `${charityId}/onboardingRequired`
          );
        }
        return paths;
      })(withModals(withStyles(s)(subscribeToResizeChanges(Header))))
    )
  )
);
